import * as React from 'react';

const formatExportValue = (val: any) => {
    if (val === null || val === undefined || val === '' || val === '-') {
        return '';
    }
    const num = parseFloat(val);
    if (!isNaN(num) && Math.abs(num) < 0.005) {
        return '';
    }
    return val;
};

const ShowOldRatio = (data: any) => {
    return (
        <>
            <div className="old-ratio">
                {
                    data.keys ?
                        Object.keys(data.keys).map((key: any) => {
                            // Use our helper to decide if we should render the row
                            const displayValue = formatExportValue(data.selectedRatio[key]);
                            
                            // If the value is effectively zero/empty, we skip the row entirely 
                            // (as per the original logic's intent)
                            if (displayValue === "") return null;

                            return (
                                <React.Fragment key={key}>
                                    <div className="row">
                                        <strong className="key-key">{data.keys[key]}</strong> 
                                        {displayValue}
                                    </div>
                                </React.Fragment>
                            )
                        })
                        : void (0)
                }
            </div>
        </>
    )
}

export default ShowOldRatio;